/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'guide-graphics/dialog-before': {
    width: 16,
    height: 16,
    viewBox: '0 0 40.5 80',
    data: '<g data-name="Layer 2"><path pid="0" d="M40.5 80C18.13 80 0 62.09 0 40S18.13 0 40.5 0z" _fill="#fff" data-name="Layer 1"/></g>'
  }
})
